import { render, staticRenderFns } from "./ImportSlider.vue?vue&type=template&id=78b6f1c6&"
import script from "./ImportSlider.vue?vue&type=script&lang=js&"
export * from "./ImportSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImportSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports